module.exports = "pegasus_template/assets/finability.png";